import {Dialog} from '@mui/material';
import React from 'react';

import {LoadingSpinner} from './LoadingSpinner';

type Props = {
  loading: boolean;
};
export const LoadingSpinnerDialog: React.FC<Props> = (props) => {
  const {loading} = props;
  if (loading) {
    setTimeout(() => {
      (document.activeElement as HTMLElement | undefined)?.blur(); // NOTE: fix console warning
    }, 0);
  }
  return (
    <Dialog open={loading} PaperProps={{style: {backgroundColor: 'transparent', boxShadow: 'none', overflow: 'visible'}}}>
      <LoadingSpinner isVisible marginTop={0} />
    </Dialog>
  );
};
